import { Functionality } from '@frontend/functionality/types';
import { getApplicationDisplayName, getApplicationIcon } from '@frontend/functionality/utils';
import { RefObject } from 'react';
import { LuChevronDown, LuChevronUp } from 'react-icons/lu';

import LicensedNavbarItem from '../licensed-navbar-item/licensed-navbar-item.component';
import useLicensedNavbarGroupItem from './licensed-navbar-group-item.controller';

const ID = 'licensed-navbar-group-item';
export interface LicensedNavbarGroupItemProps {
    navbarRef: RefObject<HTMLDivElement | null>;
    functionalities: Functionality[];
    showIcon?: boolean;
}

const LicensedNavbarGroupItem = (props: LicensedNavbarGroupItemProps) => {
    const viewProps = useLicensedNavbarGroupItem(props);

    const Icon = getApplicationIcon(props.functionalities[0]?.application);

    const styles = {
        active: 'text-brand-primary',
        inactive: 'text-foreground-default'
    };

    return (
        <div className='flex flex-col items-center justify-center self-stretch'>
            <li
                id={ID + '-' + props.functionalities[0]?.application}
                className={`group inline-flex w-full items-start justify-between px-4 py-3 font-medium ${viewProps.isOpen ? styles.active : styles.inactive} hover:bg-background-default cursor-pointer hover:rounded-md`}
                ref={viewProps.navbarGroupItemRef}
                onClick={viewProps.onClick}>
                <div className='flex h-6 items-center justify-start gap-2'>
                    {Icon && props.showIcon && (
                        <Icon className={`size-6 p-1 ${viewProps.isOpen ? 'bg-brand-accent' : 'bg-foreground-default'} text-background-surface rounded-md`} />
                    )}

                    {viewProps.expanded && <span>{getApplicationDisplayName(props.functionalities[0]?.application)}</span>}
                </div>
                {viewProps.expanded && (
                    <div
                        className={`self-center ${viewProps.isOpen ? '' : 'opacity-0 group-hover:opacity-100'}`}
                        onClick={viewProps.onChevronClick}>
                        {viewProps.isOpen ? <LuChevronUp size={16} /> : <LuChevronDown size={16} />}
                    </div>
                )}
            </li>
            {viewProps.isOpen && (
                <div
                    className='w-full'
                    ref={viewProps.navbarItemRef}>
                    {props.functionalities.map((functionality, index, array) => (
                        <div
                            key={functionality.id}
                            className={index === array.length - 1 ? 'mb-2' : ''}>
                            <LicensedNavbarItem functionality={functionality} />
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default LicensedNavbarGroupItem;
